export class PerspectiveGrid {
  constructor(canvas, vanishingPoint, options = {}) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.vp = vanishingPoint;
    this.numVertical = options.numVertical || 12;
    this.lineColor = options.lineColor || "#222";
    this.lineWidth = options.lineWidth || 1;
    this.groundSpacing = options.groundSpacing || 120; // <-- increase for more space!
    this.perspectiveExponent = options.perspectiveExponent || 1.6; // tweak for more/less compression
    this.perspectiveSpread = options.perspectiveSpread || 40; // tweak for how far lines go visually
  }

  draw(scrollDepth = 0) {
    const w = this.canvas.width;
    const h = this.canvas.height;
    const vp = this.vp.position;

    this.ctx.clearRect(0, 0, w, h);

    // Vertical lines: radiate from vanishing point to bottom edge
    for (let i = 0; i <= this.numVertical; i++) {
      const x = (i / this.numVertical) * w;
      this.ctx.save();
      this.ctx.strokeStyle = this.lineColor;
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.beginPath();
      this.ctx.moveTo(vp.x, vp.y);
      this.ctx.lineTo(x, h);
      this.ctx.stroke();
      this.ctx.restore();
    }

    // Horizontal lines: infinite ground illusion
    let lineIndex = 1;
    while (true) {
      // The t value determines spacing: lineIndex + scrollDepth/groundSpacing.
      // Increase groundSpacing for wider gaps.
      const t = (lineIndex + scrollDepth / this.groundSpacing) / this.perspectiveSpread;
      const y = vp.y + (h - vp.y) * Math.pow(t, this.perspectiveExponent);

      if (y > h) break; // Stop when offscreen
      if (y > vp.y) {
        this.ctx.save();
        this.ctx.strokeStyle = this.lineColor;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.beginPath();
        this.ctx.moveTo(0, y);
        this.ctx.lineTo(w, y);
        this.ctx.stroke();
        this.ctx.restore();
      }
      lineIndex++;
    }
  }
}